interface BrandLogoProps {
  size?: "sm" | "md" | "lg";
  onDark?: boolean;
}

export default function BrandLogo({ size = "md", onDark = false }: BrandLogoProps) {
  const markSize = size === "lg" ? "w-11 h-11" : size === "sm" ? "w-8 h-8" : "w-9 h-9";
  const textSize = size === "lg" ? "text-xl" : size === "sm" ? "text-base" : "text-lg";

  return (
    <div className="flex items-center gap-2.5">
      <span
        className={`${markSize} flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 via-primary-500 to-accent-500 text-background-50`}
      >
        <i className={`ri-heart-3-fill ${size === "lg" ? "text-xl" : "text-base"}`}></i>
      </span>
      <span
        className={`${textSize} font-heading font-semibold tracking-wide ${
          onDark ? "text-background-50" : "text-foreground-900"
        }`}
      >
        锦伴金秋
      </span>
    </div>
  );
}